import "./shimmer-components.scss";

import cn from "clsx";
import { CSSProperties } from "react";

export interface ShimmerTextProps {
  rows?: number;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";
  gap?: "xs" | "sm" | "md" | "lg";
  width?:
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "10"
    | "11"
    | "12"
    | "13"
    | "14"
    | "15"
    | "16";
  className?: string;
}

export function ShimmerText({
  rows = 1,
  width = "16",
  gap = "xs",
  size = "sm",
  className,
}: ShimmerTextProps) {
  return (
    <div className={cn("shimmer-grid", `shimmer-grid-gap--${gap}`, className)}>
      {Array.from({ length: rows }).map((_, index) => {
        const rowWidth =
          rows > 1 && index === rows - 1
            ? Math.max(parseInt(width) - 3, 1).toString()
            : width;
        return (
          <div
            key={index}
            className={cn(
              "shimmer shimmer-text",
              `shimmer-text--size-${size}`,
              `shimmer-text--width-${rowWidth}`,
            )}
          />
        );
      })}
    </div>
  );
}

export interface ShimmerButtonProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function ShimmerButton({ size = "md", className }: ShimmerButtonProps) {
  return (
    <div
      className={cn(
        "shimmer shimmer-button",
        `shimmer-button--${size}`,
        className,
      )}
    />
  );
}

export interface ShimmerImageProps {
  aspectRatio?: `${string}/${string}`;
  className?: string;
}

export function ShimmerImage({ aspectRatio, className }: ShimmerImageProps) {
  return (
    <div
      className={cn("shimmer shimmer-image", className)}
      style={{ "--aspect-ratio": aspectRatio } as CSSProperties}
    />
  );
}
